<template>
  <div class="bargain-active-index">

    <div class="d-b-c">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label=""><el-input v-model="searchForm.search" placeholder="请输入用户名称"></el-input></el-form-item>
        <el-form-item>
          <el-select size="small" placeholder="请选择" v-model="searchForm.aduit_value">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="3"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核不通过" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="nickName" label="用户名称"></el-table-column>
          <el-table-column label="用户头像">
              <template slot-scope="scope">
                  <a :href="scope.row.avatarUrl" target="_blank"><img v-img-url="scope.row.avatarUrl" width="30%" /></a>
              </template>
          </el-table-column>
          <el-table-column label="打卡任务截图">
              <template slot-scope="scope">
                  <a :href="scope.row.path" target="_blank"><img v-img-url="scope.row.path" width="30%" /></a>
              </template>
          </el-table-column>
          <el-table-column prop="coin_val" label="打卡金币"></el-table-column>
           <el-table-column prop="anchor_name" label="直播间主播名称"></el-table-column>
          <el-table-column label="直播间二维码">
            <template slot-scope="scope">
                <a :href="scope.row.notice_img" target="_blank"><img v-img-url="scope.row.notice_img" width="30%" /></a>
            </template>
          </el-table-column>
          <el-table-column prop="status_text" label="状态" ></el-table-column>
          <el-table-column prop="name" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="auditClick(scope.row.coin_id,scope.row.status)" type="text" size="small">审核</el-button>
              <el-button @click="showCoin(scope.row.coin_id,scope.row.user_id)" type="text" size="small" v-if="scope.row.coin_val==0 && scope.row.status==2">赠送金币</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>

    </div>

    <!-- 审核 -->
    <el-dialog
      title="提示"
      :visible.sync="audit_status"
      width="30%"
      >
      <el-radio-group v-model="status">
        <el-radio  label="1"  @change="changeStatus(1)">待审核</el-radio>
        <el-radio  label="2"  @change="changeStatus(2)">审核通过</el-radio>
        <el-radio  label="3"  @change="changeStatus(3)">审核不通过</el-radio> 
      </el-radio-group>
     
      <span slot="footer" class="dialog-footer">
      <el-button @click="audit_status = false">取 消</el-button>
      <el-button type="primary" @click="auditCoin()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 赠送金币 -->
    <el-dialog
      title="赠送金币"
      :visible.sync="coin_status"
      width="30%"
      >
      <el-input v-model="coinVal" placeholder="请输入金币数值"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="coin_status = false">取 消</el-button>
        <el-button type="primary" @click="sendCoin()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import AnchorApi from "@/api/anchor.js";
export default {
  components: {},
  data() {
    return {
      /*搜索表单对象*/
      searchForm: {},
      /*表单数据*/
      tableData: [],
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      commentData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      // 审核框显示
      audit_status:false,
      status:'',
      select_status : '',
      coin_status:false,
      coinVal:0,
      aduit_value:'',
      select_id:'',
      user_id : 0,
      /*审核状态*/
      options: [{
          value: 'all',
          label: '全部'
      }, {
        value: 'will',
        label: '待审核'
      }, {
        value: 'success',
        label: '审核通过'
      }, {
        value: 'fail',
        label: '审核不通过'
      }],
      value: 'all',
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
    };
  },
  created() {
    /*获取文章列表*/
    this.getTableList();
  },
  methods: {
    /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    /*获取文章列表*/
    getTableList() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      AnchorApi.anchorCoinList(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    // 审核状态
    auditClick(res,item){
      console.log(res)
      this.select_id = res;
      this.status = item.toString();
      this.audit_status = true;
    },
    // 赠送金币
    sendCoin(){
      let self = this;
      let Params = {};
      Params.coin_id = self.select_id;
      Params.coin = self.coinVal
      Params.user_id = this.user_id;

      AnchorApi.sendCoin(Params, true)
        .then(data => {
          self.coin_status = false;
          self.getTableList();
        })
        .catch(error => {});
    },
    // 赠送金币弹窗
    showCoin(res,item){
        this.coin_status = true;
        this.select_id = res;
        this.user_id = item
    },
    // 修改状态
    changeStatus(res){
      this.select_status = res
    },
    // 审核证书
    auditCoin(){
      let self = this;
      let Params = {};
      Params.coin_id = this.select_id;
      Params.status = this.select_status;      
      AnchorApi.auditCoin(Params, true)
        .then(data => {
          self.audit_status = false;
          self.getTableList();
        })
        .catch(error => {});
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/anchor/coin/index.vue